import type { VariationFe } from "@intelligems/ig-types/fe-only/variations";
import { AgGroup } from "@src/store/slices/agProducts/types";
import { shopifyProductVariantToVariationPrice } from "@src/store/slices/agProducts/util/shopifyProductVariantToVariationPrice";
import { ShopifyProduct } from "@src/store/slices/products/types";

export function shopifyProductToAgGroup(
  product: Pick<
    ShopifyProduct,
    "id" | "title" | "image" | "handle" | "variants"
  >,
  variations: VariationFe[]
) {
  const group: AgGroup = {
    id: product.id,
    products: product.variants.map((v) => ({
      productId: product.id,
      productTitle: product.title,
      productImage: product.image,
      handle: product.handle,
      variantId: v.id,
      variantTitle: v.title,
      variantPrice: v.price.toString(),
      variationPrices: variations
        .map((group) => shopifyProductVariantToVariationPrice(v, group))
        .reduce((k, v) => ({ ...k, [v.variationId]: v }), {}),
    })),
  };
  return group;
}
